import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Photo from "../ui/Photo";
import { SERVICES } from "../../data/salon";
import { duration, finalPrice, toman } from "../../lib/format";
import { Pill, SectionHead } from "../ui/Bits";

const CONCERNS = [
  { slug: "color", label: "می‌خواهم رنگ موهایم را عوض کنم", match: ["hair-color", "balayage"] },
  { slug: "glow", label: "پوستم کدر و خسته است", match: ["hydrafacial", "signature-facial", "microneedling"] },
  { slug: "event", label: "یک مراسم مهم در پیش دارم", match: ["evening-makeup", "engagement-makeup", "lash-extension"] },
  { slug: "upkeep", label: "فقط می‌خواهم مرتب باشم", match: ["cut-and-style", "gel-polish", "brow-design"] },
  { slug: "repair", label: "موهایم آسیب دیده است", match: ["hair-treatment", "keratin"] },
];

const TIMES = [
  { slug: "short", label: "کمتر از یک ساعت", test: (s) => s.duration <= 60 },
  { slug: "half", label: "یک تا دو ساعت", test: (s) => s.duration > 60 && s.duration <= 120 },
  { slug: "long", label: "بیشتر از دو ساعت", test: (s) => s.duration > 120 },
];

export default function Discovery() {
  const [concern, setConcern] = useState(CONCERNS[0].slug);
  const [time, setTime] = useState(null);

  const results = useMemo(() => {
    const c = CONCERNS.find((x) => x.slug === concern);
    let out = SERVICES.filter((s) => c.match.includes(s.slug));
    if (time) out = out.filter(TIMES.find((t) => t.slug === time).test);
    return out;
  }, [concern, time]);

  return (
    <section className="section section--defer disc">
      <div className="wrap wrap--wide">
        <SectionHead
          eyebrow="FIND YOUR SERVICE"
          title="نمی‌دانی از کجا <em>شروع</em> کنی؟"
          lede="دو سؤال، و چند پیشنهاد متناسب با همان چیزی که دنبالش هستی."
        />

        <div className="disc__panel">
          <fieldset className="disc__q">
            <legend className="disc__legend">
              <span className="disc__qn">۱</span> چه چیزی برایت مهم است؟
            </legend>
            <div className="disc__opts">
              {CONCERNS.map((c) => (
                <Pill key={c.slug} active={concern === c.slug} onClick={() => setConcern(c.slug)}>
                  {c.label}
                </Pill>
              ))}
            </div>
          </fieldset>

          <fieldset className="disc__q">
            <legend className="disc__legend">
              <span className="disc__qn">۲</span> چقدر وقت داری؟
            </legend>
            <div className="disc__opts">
              <Pill active={!time} onClick={() => setTime(null)}>فرقی ندارد</Pill>
              {TIMES.map((t) => (
                <Pill key={t.slug} active={time === t.slug} onClick={() => setTime(t.slug)}>
                  {t.label}
                </Pill>
              ))}
            </div>
          </fieldset>
        </div>

        <div className="disc__results">
          {results.length === 0 ? (
            <p className="disc__none">با این ترکیب خدمتی پیدا نشد. بازه زمانی را بازتر کن.</p>
          ) : (
            results.map((s) => (
              <Link key={s.id} to={`/services/${s.slug}`} className="dres">
                <Photo src={s.photo} ratio="1 / 1" className="dres__ph ph--hover" />
                <span className="dres__body">
                  <span className="dres__name">{s.name}</span>
                  <span className="dres__short">{s.short}</span>
                </span>
                <span className="dres__meta">
                  <span>{toman(finalPrice(s))}</span>
                  <span className="dres__dur">{duration(s.duration)}</span>
                </span>
              </Link>
            ))
          )}
        </div>
      </div>
    </section>
  );
}
